import React from 'react';
import { Spin } from '@nackle/origami';

const CenteredSpinner = () => (
    <div
        style={ {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85vh',
        } }
    >
        <Spin size="large" />
    </div>
);

export default CenteredSpinner;